GatiServerGame = function () {
  var base = new GatiServer();
  GatiServer.call(this, base);
  this.inFS = false;
  this.fsIndex = 0;
  this.fsWinnings = 0;
  this.numFsRemaining = 0;
  this.fsCount = 0;
  this.force = undefined;
  this.forceIndex = 0;
  // this.gambleForces = [];
  // this.collectForce = undefined;

  this.superFreespinsCostMultiplier = 300;
  this.freeSpinsCostMultiplier = 100;
  this.superFreespinsActive = false;

  this.addGameConfigToQueueBase = this.addGameConfigToQueue;
  this.addGameConfigToQueue = this.addGameConfigToQueueDerived;

  this.addRecoveryToQueueBase = this.addRecoveryToQueue;
  this.addRecoveryToQueue = this.addRecoveryToQueueDerived;
  // this.restorePreviousWagersBase = this.restorePreviousWagers;
  // this.restorePreviousWagers = this.restorePreviousWagersDerived;

  this.startGameBase = this.startGame;
  this.startGame = this.startGameDerived;
  this._inEncore = false;
  this._inBuyABonus = false;
  this._inBuyASuperBonus = false;
  this._rtp = 0;
  this._baseGameWinnings = 0;
  this._totalWinnings = 0;
  this._finalBaseWinnings = 0;
  this._finalFsWinnings = 0;
  this._localRngSeed = -1;

  this._baseOutcome = {
    spins: [],
  };

  // this.loadLanguageFiles = undefined; // delete me when translations are ready
};

GatiServerGame.prototype = Object.create(GatiServer.prototype);
GatiServerGame.prototype.constructor = GatiServerGame;

GatiServerGame.prototype.initServer = function (cb) {
  const self = this;
  this.init(
    function () {
      cb();
    },
    function () {},
    'ReflexGaming',
    'LEFT_TOP',
    [],
    'TOP_LEFT'
  );
};

GatiServerGame.prototype.getSupplierForceName = function () {
  return 'gati_' + this._rtp * 1000;
};

GatiServerGame.prototype.updateCurrentStake = function (newStake) {
  if (this._stake != newStake) {
    let isStakeLower = newStake < this._stake;
    this._stake = newStake;
    this._slotGame.getGameEventsEmitter().totalBetChanged(this._stake / 100);

    let sc = resourceManager.getController('stakeController');
    if (sc.isMaxStake() && !this._inReplayMode && !this._inRewatchMode && !this._isPrePaidGame && !isStakeLower) {
      this._slotGame.uiComponents().clickActionHandler();
    }
  }
};

GatiServerGame.prototype.setBPL = function (bpl) {
  let baseStake = this._numLines * bpl;
  let newStake = baseStake;
  if (gameData.encoreEnabled) {
    newStake *= 1.25;
  }

  this.updateCurrentStake(newStake);
};

GatiServer.prototype.isGameModeBonusBuy = function (mode) {
  let result = false;
  if (mode === 'BONUS_BUY_NORMAL' || mode === 'BONUS_BUY_SUPER') {
    result = true;
  }
  return result;
};

// GatiServerGame.prototype.restorePreviousWagersDerived = function () {
//   let res = this.restorePreviousWagersBase();

//   if (
//     this._previousWagers &&
//     this._previousWagers.data &&
//     this._previousWagers.data.length > 0 &&
//     this._previousWagers.data[0].bets &&
//     this._previousWagers.data[0].bets.length > 0 &&
//     this._previousWagers.data[0].bets[0].betdata.cmd === 'GOLDENBET_BUY'
//   ) {
//     this.setDefaultBet(res.baseStake);
//   }
//   return res;
// };

GatiServerGame.prototype.restorePreviousWagers = function () {
  let res = {
    baseStake: 0,
    stake: 0,
  };
  if (
    this._previousWagers &&
    this._previousWagers.data &&
    this._previousWagers.data.length > 0 &&
    this._previousWagers.data[0].bets &&
    this._previousWagers.data[0].bets.length > 0
  ) {
    // this function used to just look at the betamount, however it doesnt take into account
    // big bet (encore) or buy a bonus stakes. So we now set the base bet and let the recovery
    // resolve what the additional costs should be.
    let previousBet = Number(this._previousWagers.data[0].bets[0].betdata.coin);

    previousBet *= this._coinValue; // coin thing
    previousBet *= 100; // major to minor

    if (this._previousWagers.data[0].bets[0].betdata.cmd === 'GOLDENBET_BUY') {
      previousBet *= 10;
    }

    var stake = Number(this._previousWagers.data[0].bets[0].betamount) * 100 || previousBet;

    if (!this.isGameModeBonusBuy(this._previousWagers.data[0].bets[0].betdata.cmd)) {
      // buy a bonus isnt the default game bet, if it is a buy a bonus game dont change the default bet
      this.setDefaultBet(previousBet);
    }
    res.baseStake = previousBet;
    res.stake = stake;
  }

  return res;
};

GatiServerGame.prototype.addGameConfigToQueueDerived = function (loadData) {
  this.addGameConfigToQueueBase(loadData);
  let message = this._messageQueue[0];
  let configMessage = this._messageQueue[this._messageQueue.length - 1];

  // server is missing some config for how much scatter wins award
  // server has been updated to include this now
  // message.slotConfig.prizeTable.push({ id: 10, count: 4, value: 30 });
  // message.slotConfig.prizeTable.push({ id: 10, count: 5, value: 50 });
  // message.slotConfig.prizeTable.push({ id: 10, count: 6, value: 1000 });

  this.cheatPanelActive = loadData.customParameters.cheatPanel === 'yes';

  gameData.license = loadData.customParameters.license;

  configMessage.maxExposure = loadData.settings.slotConfig.MaxExposure;
  message.buyBonusCostSuperFreespins = this.superFreespinsCostMultiplier;
  message.buyBonusCostFreeSpins = this.freeSpinsCostMultiplier;

  gdk.addConfigValue('AllowBuyBonus', message.slotConfig.gameModes['BONUS_BUY_NORMAL'] ? true : false);

  message.slotConfig.coins = 10; // purely paytable

  gameData.recoveryStake = undefined;
  if (loadData.wagers.data.length) {
    let betData = loadData.wagers.data[0].bets[0].betdata;
    let stake = Number(betData.coin * 1000);
    gameData.recoveryStake = stake;
    if (betData.cmd === 'GOLDENBET_BUY') {
      gameData.recoveryStake *= 10;
      gameData.recoveryStake *= 1.25;
    }
  }

  this._rtp = message.slotConfig.rtp;

  let stopDistances2and5 = [17, 23, 29, 35, 41];
  let stopDistances3 = [30, 36, 42, 48, 54];
  let stopDistances5 = [49, 61, 73, 85, 97];
  switch (this._license) {
    case 'uk':
      message.stopDistances = stopDistances2and5;
      break;
    case 'UKGCRtsTest':
      message.stopDistances = stopDistances2and5;
      break;
    case 'bgc':
      message.stopDistances = stopDistances2and5;
      break;
    case 'es':
      message.stopDistances = stopDistances3;
      break;
    case 'se':
      message.stopDistances = stopDistances3;
      break;
    case 'dk':
      message.stopDistances = stopDistances3;
      break;
    case 'cz':
      message.stopDistances = stopDistances2and5;
      break;
    case 'co':
      message.stopDistances = stopDistances3;
      break;
    case 'agcc':
      message.stopDistances = stopDistances2and5;
      break;
    case 'de':
      message.stopDistances = stopDistances5;
      break;
    default:
      message.stopDistances = stopDistances3;
      break;
  }
};

GatiServerGame.prototype.addRecoveryToQueueDerived = function () {
  for (let i = 0; i < this._latestEngineReponse.wager.bets.length; ++i) {
    let bet = this._latestEngineReponse.wager.bets[i];
    if (bet.betdata.cmd === 'GOLDENBET_BUY') {
      this._inEncore = true;
      this._meta = {
        name: 'encore',
        value: true,
      };
      break;
    } else if (bet.betdata.cmd === 'BONUS_BUY_NORMAL') {
      this.superFreespinsActive = false;
      this._inBuyABonus = true;
      this._meta = {
        name: 'buyABonus',
        value: true,
      };
      break;
    } else if (bet.betdata.cmd === 'BONUS_BUY_SUPER') {
      this.superFreespinsActive = true;
      this._inBuyASuperBonus = true;
      this._meta = {
        name: 'buyASuperBonus',
        value: true,
      };
      break;
    }
  }
  this.addRecoveryToQueueBase();
};

GatiServerGame.prototype.gameForces = function (json) {
  if (typeof json === 'string') {
    this._forces = [];
    const parsed = JSON.parse(json);
    if (Array.isArray(parsed)) {
      for (let i = 0; i < parsed.length; i++) {
        this._forces[i] = JSON.stringify(parsed[i]);
      }
    } else {
      // only 1
      this._forces[0] = json;
    }
  } else {
    // already an array? assuming its come from the demo tab
    this._forces = json;
  }
  this.forceIndex = 0;
};

GatiServerGame.prototype.startGameDerived = function (stakeData, cb) {
  this._finalBaseWinnings = 0;
  this._totalWinnings = 0;
  this._inEncore = stakeData.metaData.encore;
  this._inBuyABonus = stakeData.metaData.buyABonus;
  this.superFreespinsActive =
    stakeData.metaData.superFreespinsActive !== undefined ? stakeData.metaData.superFreespinsActive : false;

  // this.gambleForces = [];
  // this.collectForce = undefined;

  if (this._forces === undefined || !this._forces) {
    this._forces = '';
    this.forceIndex = 0;
    this.addCheatToRequest(stakeData, this._forces);
  }

  this.startGameBase(stakeData, cb);
};

GatiServerGame.prototype.addMetaDataToSpinRequest = function (request) {
  let stakeController = resourceManager.getController('stakeController');
  let baseStake = stakeController.getBaseStake('default') / 100;

  this._coinValue = 10;
  request.coin = request.amount / this._coinValue;
  request.coins = this._coinValue;

  if (this._forces === '' && this.cheatPanelActive) {
    request.cheat = JSON.stringify(null);
  }

  // this doesnt alter the data we receive, its more about
  // recovery
  request.clientParams = JSON.stringify({
    Params: { mode: gameController.gambleModeIndex },
  });

  if (this._inEncore) {
    request.coins = 125;
    this._coinValue = 100; // has to be whole number
    request.amount = baseStake * 1.25;
    request.coin = baseStake / this._coinValue; // should be 0.1 on a base stake of £1, so £1.50 for lucky bet
    request.cmd = 'GOLDENBET_BUY';
  } else if (this._inBuyABonus) {
    baseStake = stakeController.getBaseStake(this.superFreespinsActive ? 'BONUS_BUY_SUPER' : 'BONUS_BUY_NORMAL') / 100;
    request.amount =
      baseStake * (this.superFreespinsActive ? this.superFreespinsCostMultiplier : this.freeSpinsCostMultiplier);
    request.coins = this.superFreespinsActive ? 40000 : 10000;
    request.coin = baseStake / this._coinValue;
    request.cmd = this.superFreespinsActive ? 'BONUS_BUY_SUPER' : 'BONUS_BUY_NORMAL';
  }
};

GatiServerGame.prototype.getPopData = function (winsInView, payWaysWins, isCapped, isFinalCapped) {
  let winnings = 0;
  for (let i = 0; i < payWaysWins.length; i++) {
    winnings += payWaysWins[i].totalWin;
  }

  const data = {
    type: 'spinner:WinningLinesEvent',
    totalLineWinnings: winnings,
    winAmount: winnings,
    isCapped: isCapped && isFinalCapped,
    isFinalCapped: isFinalCapped,
    payWaysLeft: {
      // will use left for now
      payWaysWins: payWaysWins,
    },
    removedCoords: [],
    // old data - which i believe can be removed later on
    finalStopWindow: null,
    payWaysRight: {
      payWaysWins: [],
    },
    payWays5X: {
      payWaysWins: [],
    },
    wildAddedCoord: null,
    tntModifier: {
      isAwarded: false,
    },
    specialReward: null,
    extraLivesFinal: 0,
    trailFinal: 0,
    leftMultiplierIncrease: 0,
    rightMultiplierIncrease: 0,
    leftMultiplierFinal: 1,
    rightMultiplierFinal: 1,
    leftMultiplierInc: 0,
    rightMultiplierInc: 0,
  };

  // build removedCoords
  const wins = data.payWaysLeft.payWaysWins;
  for (let i = 0; i < wins.length; i++) {
    data.removedCoords = data.removedCoords.concat(wins[i].winSymPositions);
  }

  return data;
};

GatiServerGame.prototype.getDropData = function (
  winInView,
  nextWinInView = null,
  popData,
  grid,
  isCapped,
  isFinalCapped
) {
  const data = {
    type: 'game:DropEvent',
    tumbleData: null,
    window: null,
    isCapped: isCapped && isFinalCapped,
    isFinalCapped: isFinalCapped,
    eggMultipliers: null,

    // anything below i think is specific to dead lucky
    cells: [],
    trailCount: 0,
    specialReward: false,
    leftMultiplierInc: 0,
    rightMultiplierInc: 0,
    leftMultiplierFinal: 1,
    rightMultiplierFinal: 1,
    extraLivesFinal: 0,
    extraWild: null,
  };

  const popWindow = [
    [0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0],
  ];

  // go through the winning symbol data, changing 0 to -1
  const poppedSymbols = popData.removedCoords;
  for (let i = 0; i < poppedSymbols.length; ++i) {
    let cell = poppedSymbols[i];
    popWindow[cell.reel][cell.row] = -1;
    grid[cell.reel][cell.row] = -1;
  }

  // grid has had the winning symbols removed
  // we need to move everything towards the end of the array and push in the new ones
  // first lets just remove the -1
  for (let i = 0; i < grid.length; i++) {
    grid[i] = grid[i].filter((value) => value !== -1);
  }
  // then shift in the new numbers
  let eggsDetected = false;
  for (let i = 0; i < winInView.cascadedIn.length; i++) {
    const reelIndex = winInView.cascadedIn[i].reel;
    if (winInView.cascadedIn[i].symbols.indexOf(20) !== -1) {
      eggsDetected = true;
    }
    grid[reelIndex] = winInView.cascadedIn[i].symbols.concat(grid[i]);
  }

  const newWindow = [];

  // now build symbols to drop in
  for (let i = 0; i < grid.length; i++) {
    let slot = [];
    for (let k = 0; k < grid[i].length; k++) {
      slot.push({ _id: grid[i][k] });
    }
    newWindow.push(slot);
  }

  data.tumbleData = popWindow;
  data.window = newWindow;
  // let multiplierInfo = null;
  // if (winInView.multipliers && nextWinInView && nextWinInView.multipliers) {
  //   multiplierInfo = _.union([], winInView.multipliers, nextWinInView.multipliers);
  // } else if (winInView.multipliers) {
  //   multiplierInfo = _.union([], winInView.multipliers);
  // }
  data.eggMultipliers = Array.isArray(winInView.multipliers) ? winInView.multipliers : null;

  data.hasCascades = nextWinInView ? true : false;

  return data;
};

GatiServerGame.prototype.getPayWaysWinsData = function (winData) {
  const payWaysWins = [];

  const wildData = winData.usedWildCoords;

  // multiple wins per drop are in the symbol array
  for (let i = 0; i < winData.symbol.length; i++) {
    const symbol = winData.symbol[i];
    const data = {
      symbol: symbol.symbolId,
      count: symbol.thisSymbolCoords.length,
      coords: symbol.thisSymbolCoords,
      baseWin: symbol.winAmount,
      waysCount: 0,
      totalWin: symbol.winAmount,
      winSymPositions: [],
    };

    // and we also need to populate winSymPositions
    for (let k = 0; k < symbol.thisSymbolCoords.length; k++) {
      const coords = symbol.thisSymbolCoords[k];
      const exactSymbolsUsed = symbol.exactSymbolsUsed[k];
      const symPosData = {
        reel: coords.reel,
        row: coords.row,
        sym: exactSymbolsUsed,
      };
      data.winSymPositions.push(symPosData);
    }

    for (let k = 0; k < wildData.length; k++) {
      const coords = wildData[k];
      const symPosData = {
        reel: coords.reel,
        row: coords.row,
        sym: 9,
      };
      data.coords.push(symPosData);
      data.winSymPositions.push(symPosData);
    }

    // wilds may be in a different array

    payWaysWins.push(data);
  }

  return payWaysWins;
};

GatiServerGame.prototype.buildDynamicGrid = function (spinData) {
  const grid = [];

  for (let i = 0; i < spinData.initialStopWindow.reelList.length; i++) {
    const reelList = spinData.initialStopWindow.reelList[i];
    for (let k = 0; k < reelList.symbols.length; k++) {
      if (!grid[i]) {
        grid[i] = [];
      }
      grid[i][k] = reelList.symbols[k].value;
    }
  }

  return grid;
};

GatiServerGame.prototype.getSpinDataNormal = function (spinData, eggMultiplierData = null) {
  if (!this.validateResponse(spinData)) return;

  this.addSpinDataToQueue(spinData, eggMultiplierData);

  if (spinData.winsInView?.winInView?.length > 0) {
    this.addPopsAndDropsToQueue(spinData);
  }

  this.addPopsAndDropsCompleteToQueue(spinData);

  return spinData.winAmount;
};

GatiServerGame.prototype.addPopsAndDropsToQueue = function (spinData) {
  // build our own grid layout which will update
  // as we process the pop data from the server
  const grid = this.buildDynamicGrid(spinData);

  for (let i = 0; i < spinData.winsInView.winInView.length; i++) {
    const winInView = spinData.winsInView.winInView[i];
    let nextWinInView = null;
    if (i !== spinData.winsInView.winInView.length - 1) {
      nextWinInView = spinData.winsInView.winInView[i + 1];
    }

    // each winInView could have multiple wins
    // these are in symbols
    // we need to convert symbols to payWaysWins
    const payWaysWinsData = this.getPayWaysWinsData(winInView);

    const popData = this.getPopData(
      spinData.winsInView,
      payWaysWinsData,
      spinData.winCapped,
      i === spinData.winsInView.winInView.length - 1
    );
    this._messageQueue.push(popData);
    // then drop in new symbols
    const dropData = this.getDropData(
      winInView,
      nextWinInView,
      popData,
      grid,
      spinData.winCapped,
      i === spinData.winsInView.winInView.length - 1
    );
    this._messageQueue.push(dropData);
  }
};

// GatiServerGame.prototype.getSpinDataNormalOLD = function (data) {
//   let spinEvent = data.spin;
//   let spinData = data.spin.cascades;
//   if (!this.validateResponse(spinEvent)) return;

//   let leftMultiplierInc = 0;
//   let rightMultiplierInc = 0;
//   let leftMultiplierFinal = 0;
//   let rightMultiplierFinal = 0;

//   let isCapped = data.isCapped;

//   let length = spinData.length - 1;

//   if (isCapped) {
//     length = spinData.length;
//   }

//   let isNotFinal = true;

//   this.addSpinDataToQueue(spinEvent);

//   let totalWinInBase = 0;
//   let extraLives = 0;
//   totalWinInBase += data.spin.winAmount;

//   this._baseGameWinnings += data.spin.winAmount;

//   for (let i = 0; i < length; ++i) {
//     let isNotFinal = spinData[i + 1];

//     let winningLineEvent = spinData[i];

//     if (isNotFinal) {
//       let poppedSymbols = spinData[i + 1].removedCoords;

//       if (spinData[i + 1].wildAddedCoord) {
//         let lowestRow = spinData[i + 1].wildAddedCoord.row;
//         var wildReel = spinData[i + 1].wildAddedCoord.reel;

//         poppedSymbols.forEach((symbol) => {
//           if (symbol.reel === wildReel) {
//             if (symbol.row === lowestRow + 1) {
//               lowestRow = symbol.row;
//               spinData[i + 1].wildAddedCoord.row = symbol.row;
//             }
//           }
//         });
//       }

//       extraLives = spinData[i + 1].extraLivesFinal;

//       if (spinData[i].tntModifier.isAwarded) {
//         let finalStopWindow = JSON.parse(
//           JSON.stringify(spinEvent.cascades[i].finalStopWindow.reelList)
//         );
//         this.addModifierEventToQueue(
//           spinEvent.cascades[i].tntModifier,
//           finalStopWindow,
//           winningLineEvent
//         );
//       }

//       /**
//        * SpecialReward for wild modifiers
//        * Types are: double wild, multiplier boost,wild stack,extra life
//        */
//       let specialReward;
//       let message = {};

//       trailCount = spinData[i + 1].trailFinal;

//       if (spinData[i + 1].specialReward !== null) {
//         specialReward = spinData[i + 1].specialReward;
//       } else {
//         specialReward = null;
//       }

//       let extraWildCoord = null;

//       if (specialReward?.type == "DoubleWild") {
//         message.DoubleWildCoord = specialReward.wildAddedCoord;
//         extraWildCoord = [specialReward.wildAddedCoord];

//         let lowestRow = extraWildCoord.row;
//         var doubleWildReel = extraWildCoord.reel;

//         poppedSymbols.forEach((symbol) => {
//           if (symbol.reel === doubleWildReel) {
//             if (symbol.row > lowestRow) {
//               lowestRow = symbol.row;
//               extraWildCoord.row = symbol.row;
//             }
//           }
//         });
//       } else if (specialReward?.type == "MultiplierBoost") {
//         message.leftMultiplierInitial = specialReward.leftMultiplierInitial;
//         message.rightMultiplierInitial = specialReward.rightMultiplierInitial;
//         message.leftMultiplierFinal = specialReward.leftMultiplierFinal;
//         message.rightMultiplierFinal = specialReward.rightMultiplierFinal;
//       } else if (specialReward?.type == "WildStack") {
//         var reel = spinData[i + 1].wildAddedCoord.reel;
//         extraWildCoord = [];

//         for (let j = 0; j < 3; j++) {
//           extraWildCoord.push({ reel: reel, row: j });
//         }
//       }

//       message = specialReward;

//       leftMultiplierInc = spinData[i + 1].leftMultiplierIncrease;
//       rightMultiplierInc = spinData[i + 1].rightMultiplierIncrease;
//       leftMultiplierFinal = spinData[i + 1].leftMultiplierFinal;
//       rightMultiplierFinal = spinData[i + 1].rightMultiplierFinal;

//       this.addPopsToQueue(
//         winningLineEvent,
//         spinData[i].winAmount,
//         leftMultiplierInc,
//         rightMultiplierInc,
//         leftMultiplierFinal,
//         rightMultiplierFinal,
//         isCapped,
//         false
//       );
//       this.addDropsToQueue(
//         spinData[i + 1].finalStopWindow.reelList,
//         spinData[i + 1].wildAddedCoord,
//         poppedSymbols,
//         message,
//         trailCount,
//         leftMultiplierInc,
//         rightMultiplierInc,
//         leftMultiplierFinal,
//         rightMultiplierFinal,
//         extraLives,
//         extraWildCoord
//       );
//     } else {
//       this.addPopsToQueue(
//         winningLineEvent,
//         spinData[i].winAmount,
//         leftMultiplierInc,
//         rightMultiplierInc,
//         leftMultiplierFinal,
//         rightMultiplierFinal,
//         isCapped,
//         true
//       );
//     }
//   }

//   /**
//    * Tnt modifier in cascades
//    */
//   for (let i = 0; i < this._messageQueue.length; i++) {
//     if (this._messageQueue[i].tntModifier !== undefined) {
//       if (this._messageQueue[i].tntModifier.isAwarded) {
//         let fakeSymbols = this._messageQueue[i].tntModifier.replacementSymbols;
//         let fakeSymbolsLength =
//           this._messageQueue[i].tntModifier.replacementSymbols.length;
//         let reel = this._messageQueue[i].tntModifier.reelToHide;
//         let dropMessage = this._messageQueue[i - 3]; // get the drop modifier event

//         for (let j = 0; j < fakeSymbolsLength; j++) {
//           for (let j = 0; j < fakeSymbolsLength; j++) {
//             if (dropMessage.window !== undefined) {
//               dropMessage.window[reel][j]._id = fakeSymbols[j];
//             } else if (dropMessage.resultPanel.reelList !== undefined) {
//               dropMessage.resultPanel.reelList[reel].symbols[j].value =
//                 fakeSymbols[j];
//             }
//           }
//         }
//       }
//     }
//   }

//   this.addPopsAndDropsCompleteToQueue(totalWinInBase);

//   return totalWinInBase;
// };

GatiServer.prototype.addSpinDataToQueue = function (event, eggMultiplierData = null) {
  const message = {};
  message.type = 'spinner:SpinEvent';

  message.panelMultiplier = 1;
  message.isPrePaidGame = this._isPrePaidGame;
  message.baseBet = this._stake;
  message.betMultiplier = 1;
  message.totalWinnings = event.winAmount;
  if (event.jackpotGame !== undefined && event.jackpotGame === true) {
    message.jackpotGame = true;
  }

  message.resultPanel = {};
  message.resultPanel.reels = event.initialStopWindow.reels;
  message.resultPanel.rectangular = true;
  message.resultPanel.reelList = event.initialStopWindow.reelList;
  message.resultPanel.symbolsAbove = undefined;
  message.resultPanel.symbolsBelow = undefined;

  message.hasCascades = false;
  message.hasWins = false;
  if (event.winsInView?.winInView?.length > 0) {
    message.hasWins = true;
    message.hasCascades = true;
  } else if (event.spinsAdded > 0) {
    message.hasWins = true;
  }

  message.eggMultiplierData = eggMultiplierData;

  if (this._localRngSeed !== -1) {
    message.localRng = this._localRngSeed;
  }

  this._messageQueue.push(message);
};

// for reference!!!!
// GatiServerGame.prototype.getSpinDataNormal = function (spinData) {
//   if (!this.validateResponse(spinData)) return;

//   this.addSpinDataToQueue(spinData);

//   if (spinData.winsInView.winInView.length > 0) {
//     this.addPopsAndDropsToQueue(spinData);
//   }

//   this.addPopsAndDropsCompleteToQueue(spinData);

//   return spinData.winAmount;
// };

// GatiServerGame.prototype.findMultiplierCombinationsFor = function (target, numbers, count, minValue = 0) {
//   const results = [];

//   // Only use numbers >= minValue
//   const filteredNumbers = numbers.filter((n) => n >= minValue).sort((a, b) => a - b);

//   function backtrack(remaining, combo, start) {
//     if (remaining === 0 && combo.length === count) {
//       results.push([...combo]);
//       return;
//     }

//     if (combo.length >= count || remaining < 0) return;

//     for (let i = start; i < filteredNumbers.length; i++) {
//       const num = filteredNumbers[i];
//       combo.push(num);
//       backtrack(remaining - num, combo, i); // allow reuse
//       combo.pop();
//     }
//   }

//   backtrack(target, [], 0);
//   return results;
// };

// // i shouldnt be having to do this!!!!
// GatiServerGame.prototype.createEggMultiplierData = function (freeSpins) {
//   // use the gameControllers rng to randomly pick multipliers
//   // this way the results can be replicated in replay
//   // gameController.rng.nextInt()

//   const EGG_ID = resourceManager.getConfiguration().symbols['GoldenEggSmall'].ID;
//   const minTrailMultipliers = [2, 5, 10, 15, 20, 25, 50, 100];
//   const possibleMultipliers = [2, 3, 4, 5, 6, 8, 10, 12, 15, 20, 25, 50, 100, 1000];
//   let currentTrailPosition = 0;
//   let currentMinMultiplier = buyBonusPopup.superFreespinsSelected ? 20 : 2;
//   let currentTrailLevel = minTrailMultipliers.indexOf(currentMinMultiplier);

//   const resultData = [];

//   for (let fs = 0; fs < freeSpins.length; fs++) {
//     resultData[fs] = {
//       eggsDroppingInAtStart: [],
//     };
//     const fsData = freeSpins[fs];
//     // going to keep a track of my own multiplier
//     // const minimumMultiplier = fsData.minimumMultiplier === 0 ? 2 : fsData.minimumMultiplier;
//     const combinedMultiplier = fsData.combinedMultiplier;

//     // do we have any eggs dropping in from the start
//     let eggsDroppingInAtStart = [];
//     for (let r = 0; r < fsData.initialStopWindow.reelList.length; r++) {
//       for (let c = 0; c < fsData.initialStopWindow.reelList[r].symbols.length; c++) {
//         if (fsData.initialStopWindow.reelList[r].symbols[c].value === EGG_ID) {
//           resultData[fs].eggsDroppingInAtStart.push({ reel: r, row: c, multiplier: 1 });
//         }
//       }
//     }

//     if (resultData[fs].eggsDroppingInAtStart.length > 0) {
//       // we have eggs dropping in on initial drop
//       if (fsData.winAmount === 0) {
//         console.log('eggs detected on initial drop but NO WIN');
//         const availableCombinations = this.findMultiplierCombinationsFor(
//           combinedMultiplier,
//           possibleMultipliers,
//           resultData[fs].eggsDroppingInAtStart.length,
//           currentMinMultiplier
//         );

//         // pick a random index
//         const randomIndex = gameController.rng.randomNumberFromTo(0, availableCombinations.length - 1);
//         for (let i = 0; i < resultData[fs].eggsDroppingInAtStart.length; i++) {
//           resultData[fs].eggsDroppingInAtStart[i].multiplier = availableCombinations[randomIndex][i];
//         }
//       } else {
//         console.log('eggs detected on initial drop with WIN - no rules in place yet');
//         // we will be winning something
//         // we need to look ahead and see if we will be needing to upgrade multipliers at
//         // some point
//         // add if we will be getting more eggs dropping in from cascades
//       }
//     }

//     if (fsData.winAmount > 0) {
//       // we are winning
//       // we now need to look to see whats going on with each cascade
//       // each cascade also increases the trail etc
//       // now in winInView there is a multipliers array
//       // which contains info about some eggs. but are these new eggs or existing ones?
//       for (let i = 0; i < fsData.winsInView.winInView.length; i++) {
//         // do stuff

//         // now thats done
//         // is the trail already full?
//         if (currentTrailLevel >= minTrailMultipliers.length - 1) {
//           // trail is full
//           // we cant add anymore
//         } else {
//           currentTrailPosition++;
//           if (currentTrailPosition >= 5) {
//             currentTrailLevel++;
//             currentMinMultiplier = minTrailMultipliers[currentTrailLevel];
//             currentTrailPosition = 0;
//           }
//         }
//       }
//     }
//   }

//   console.log('resultData', resultData);

//   return resultData;
// };

GatiServerGame.prototype.getSpinDataFS = function (cb, finalData) {
  // if (this.fsCount === 0) {
  //   this.eggMultiplierData = this.createEggMultiplierData(this.freeSpins);
  // }

  // const eggMultiplierData = this.eggMultiplierData[this.fsCount];
  const data = this.freeSpins[this.fsCount++];
  --this.numFsRemaining;
  let spinEvent = data;

  this._combinedMultiplier = data.combinedMultiplier;
  this._finalBaseWinnings = data.winAmount;
  this._finalBaseWinningsPreMult = data.winAmountPreMult;
  this._finalBaseWinningsInitialScatterWin = data.bonusScatterWins;
  this._finalBaseWinningsInitialScatterWinPreMult = data.bonusScatterWinsPreMult;
  this._finalBaseWinningsNoScatter = data.winAmountNoScatter;
  this._finalBaseWinningsNoScatterPreMult = data.winAmountNoScatterPreMult; // this doesnt exist yet!

  // this should do it
  const won = this.getSpinDataNormal(spinEvent, data.initialMultipliers);

  let spinWin = 0;
  spinWin += data.winAmount;

  let isCapped = data.winCapped;

  this.fsWinnings += won;

  if (this.fsCount < this.freeSpins.length) {
    // before we request a new spin
    if (data.spinsAdded > 0) {
      this.addFSRetriggerToQueue(data);
    }

    this.addFSDataToQueue();
  } else {
    this.addFSEndToQueue(isCapped);
    this.addGameCompleteToQueue(this.fsWinnings);
    this.inFS = false;
    this.numFsRemaining = 0;
  }

  cb();

  this.triggerNextMessage();
};

// GatiServerGame.prototype.addFSAwardToQueue = function (data) {
//   let numFS = [7, 9, 11, 16];
//   let numScatters;

//   if (data.spinsCountOnWin === 16) {
//     data.spinsCount = 11;
//     numScatters = 4;
//   } else if (data.spinsCountOnWin === 11) {
//     data.spinsCount = 9;
//     numScatters = 3;
//   } else if (data.spinsCountOnWin === 9) {
//     data.spinsCount = 7;
//     numScatters = 2;
//   }

//   var message = {};
//   message.type = 'game:FreeSpinsAwardEvent';
//   message.freeSpinsAwarded = numFS[numScatters - 3];
//   message.possibleValues = numFS;
//   message.numScatters = numScatters;
//   message.nextFreespins = numFS[numScatters - 2];
//   message.winChance = data.winChance;
//   message.loseChance = data.loseChance;
//   message.buyABonus = this._inBuyABonus;
//   message.buyASuperBonus = this._inBuyASuperBonus;
//   message.numFreeSpins = data.spinsCount;
//   let self = this;
//   message.resultCallback = function (obj, cb) {
//     self.sendGambleResponseToServer(numScatters, obj.response, cb);
//   };

//   this._messageQueue.push(message);
// };

// GatiServerGame.prototype.addGambleResultToQueue = function (won) {
//   var message = {};
//   message.type = "fire_gems:GambleResultEvent";
//   message.won = won;
//   this._messageQueue.push(message);
// };

GatiServerGame.prototype.addGambleResultToQueue = function (result) {
  var message = {};
  message.type = 'spinner:GambleResultEvent';
  message.bonusGambleOptions = result.bonusGambleOptions;
  message.cashGambleOptions = result.cashGambleOptions;
  message.otherGambleSpinStop = result.otherGambleSpinStop;
  message.won = result.currentCashWin;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.getSpinData = function (cb, data) {
  if (this.inFS) {
    this.getSpinDataFS(cb, data);
    return;
  }

  // this._forces = '';

  let parts = data.Parts;

  let totalWon = 0;
  this._localRngSeed = -1;

  for (let i = 0; i < parts.length; ++i) {
    let type = parts[i].type;
    if (type === 'baseGame') {
      this._bonusCollectedFromGamble = false;
      this._finalBaseWinnings = parts[i].winAmount;
      this._finalBaseWinningsPreMult = parts[i].winAmountPreMult;
      this._finalBaseWinningsInitialScatterWin = parts[i].initialScatterWin;
      this._triggeringScatterWins = this._finalBaseWinningsInitialScatterWin;
      this._finalBaseWinningsInitialScatterWinPreMult = parts[i].initialScatterWinPreMult;
      this._finalBaseWinningsNoScatter = parts[i].winAmountNoScatter;
      this._finalBaseWinningsNoScatterPreMult = parts[i].winAmountNoScatterPreMult; // this doesnt exist yet!
      this._localRngSeed = data.ResultId;
      // at some point the server stopped including the scatter win in winAmountSoFar
      // this._baseGameWinnings = this._finalBaseWinningsNoScatter; // used to create a value to pass at the end of the drop
      this._baseGameWinnings = this._finalBaseWinnings; // used to create a value to pass at the end of the drop
      totalWon += this.getSpinDataNormal(parts[i]);
      // base game only, game complete
      if (parts.length === 1) {
        this.addGameCompleteToQueue(totalWon);
      }
    } else if (type === 'gambleStart') {
      this._bonusCollectedFromGamble = false;
      this.addGambleDataToQueue(parts[i]);
      this.inGamble = true;
    } else if (type === 'gambleResult') {
      switch (parts[i].resultKind) {
        default:
          // 4 is win cash gamble
          // 5 is win bonus gamble
          this.addGambleResultToQueue(parts[i]);
          this._totalWinnings = parts[i].currentCashWin;
          break;

        case 0:
        // lose cash gamble
        case 1:
          // lose bonus gamble
          this.inGamble = false;
          this._totalWinnings = parts[i].currentCashWin;
          this.addGambleResultToQueue(parts[i]);
          this.addGameCompleteToQueue(this._totalWinnings);
          break;

        case 2:
          // collect cash
          this.inGamble = false;
          this.addGameCompleteToQueue(this._totalWinnings);
          break;

        case 3:
          // collect bonus
          this.inGamble = false;
          this._totalWinnings = 0;
          this._finalBaseWinnings = 0;
          this._baseGameWinnings = 0;
          this._bonusCollectedFromGamble = true;
          break;
      }
    } else if (type === 'freeSpins') {
      this.inGamble = false;
      this.inFS = true;
      this.fsCount = 0;
      this.freeSpins = parts[i].spins;
      this._finalFsWinnings = parts[i].winAmount;
      this._totalWinnings = this._finalBaseWinnings + this._finalFsWinnings;
      this.addFSStartToQueue(parts[i].initialSpins, parts[i].winCapped);
    }
  }

  cb();
  this.triggerNextMessage();
};

// GatiServerGame.prototype.addPopsToQueue = function (message) {
//   this._messageQueue.push(message);
// };

// GatiServerGame.prototype.addDropsToQueue = function (message) {
//   this._messageQueue.push(message);
// };

GatiServerGame.prototype.addPopsAndDropsCompleteToQueue = function (spinData) {
  var message = {};
  message.type = 'game:PopAndDropComplete';
  if (this.inFS) {
    // winAmountSoFar contains the original scatter win which triggered free spins
    // this._baseGameWinnings contains just base game wins - the scatter win which triggered free spins
    // i cant just use winAmountSoFar as its just free spins + original scatter win, so i recreate
    // lets hope max win doesnt ruin the day
    message.wonSoFar = this._baseGameWinnings + spinData.winAmountSoFar;
  }
  message.finalMultiplier = this._combinedMultiplier;
  message.winnings = spinData.winAmount;
  message.isCapped = spinData.winCapped;
  message.cascadeClimber = spinData.cascadeClimber;
  message.finalBaseWinnings = this._finalBaseWinnings;
  message.finalBaseWinningsPreMult = this._finalBaseWinningsPreMult;
  message.finalBaseWinningsInitialScatterWin = this._finalBaseWinningsInitialScatterWin;
  message.finalBaseWinningsInitialScatterWinPreMult = this._finalBaseWinningsInitialScatterWinPreMult;
  message.finalBaseWinningsNoScatter = this._finalBaseWinningsNoScatter;
  message.finalBaseWinningsNoScatterPreMult = this._finalBaseWinningsNoScatterPreMult;

  // i want to include the
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addFSStartToQueue = function (numFs, isCapped) {
  this.fsWinnings = 0;
  var message = {};
  message.type = 'game:FreeSpinsStartEvent';
  message.freeSpinsAwarded = numFs;
  message.fromGamble = this._bonusCollectedFromGamble;

  // is this needed?
  // if (isCapped) {
  //   message.freeSpinsAwarded = 16;
  // }

  message.bonuswin = 0;
  // message.currentMultiplier = 1;
  // message.nextMultiplier = 2;
  // this.inGamble = false;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addFSRetriggerToQueue = function (data) {
  var message = {};
  message.type = 'game:FreeSpinsRetriggerDataEvent';
  message.numRemaining = this.numFsRemaining;
  message.spinsAdded = data.spinsAdded;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addFSDataToQueue = function () {
  var message = {};
  message.type = 'game:FreeSpinsDataEvent';
  message.num = this.numFsRemaining;
  message.fsWinnings = this.fsWinnings;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addFSEndToQueue = function (isCapped) {
  var message = {};
  message.type = 'game:FreeSpinsEndEvent';
  message.fsWinnings = this.fsWinnings;
  message.finalFsWinnings = this._finalFsWinnings;
  message.totalWinnings = this._totalWinnings;
  message.triggeringScatterWins = this._triggeringScatterWins;
  message.isCapped = isCapped;
  message.fsCount = this.fsCount;
  this.fsWinnings = 0;
  this.inFS = false;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addGambleDataToQueue = function (data) {
  var message = {};

  message.type = 'spinner:GambleDataEvent';

  message.isCapped = data.winCapped;
  message.bonusGambleOptions = data.bonusGambleOptions;
  message.cashGambleOptions = data.cashGambleOptions;
  message.collectionOptions = data.collectionOptions;

  let self = this;
  message.resultCallback = function (obj, cb) {
    self.sendGambleResponseToServer(obj.response, cb);
  };
  this._messageQueue.push(message);
};

GatiServerGame.prototype.sendGambleResponseToServer = function (response, cb) {
  if (this._gameNotFullyRecovered) {
    // no need to send state, already done and part of recovery
    this.moveToNextBetData();
    messageBus.postImmediate('Gamble:HandledCommand');
    timerManager.addTimer(500, undefined, cb);
    return;
  }

  this.resetCurrentBetData();

  let self = this;

  let nextStep = this._latestEngineReponse.wager.bets[this._latestEngineReponse.wager.bets.length - 1].step + 1;

  let playData = {
    cmd: response,
    step: nextStep,
    clientParams: '',
  };

  if (this.cheatPanelActive) {
    playData.cheat = JSON.stringify(null);
  }
  this.addCheatToRequest(playData, this._forces);

  // if (this.gambleForces.length > 0) {
  //   playData.cheat = this.gambleForces.shift();
  // } else if (this.collectForce !== undefined) {
  //   playData.cheat = this.collectForce;
  //   this.collectForce = undefined;
  // } else if (this.cheatPanelActive) {
  //   playData.cheat = JSON.stringify(null);
  // }

  const sendCommand = async () => {
    self._latestEngineReponse = await self._slotGame.play(playData);
    self._forces = self.updateForces(self._forces);

    cb();
  };

  sendCommand().then(() => {
    if (response === 'COLLECT') {
      messageBus.postImmediate('Gamble:Collect');
    } else {
      messageBus.postImmediate('spinner:GambleCommandSent');
    }
  });
};

GatiServer.prototype.addRecoveryToQueue = function () {
  let clientParams = {};
  let commandsSent = [];

  // for (let i = this._previousWagers.data[0].bets.length - 1; i >= 0; --i) {
  //   if (
  //     this._previousWagers.data[0].bets[i].betdata &&
  //     this._previousWagers.data[0].bets[i].betdata.cmd === "Checkpoint"
  //   ) {
  //     clientParams = this._previousWagers.data[0].bets[i].betdata.clientParams;
  //     break;
  //   }
  // }

  // replace above code with this so we can get players choice with the gamble button
  clientParams = this._previousWagers.data[0].bets[0].betdata.clientParams;

  for (let i = 0; i < this._previousWagers.data[0].bets.length; ++i) {
    if (this._previousWagers.data[0].bets[i].betdata) {
      commandsSent.push(this._previousWagers.data[0].bets[i].betdata.cmd);
    }
  }

  let lastEventData = this._previousWagers.data[0].bets[this._previousWagers.data[0].bets.length - 1].eventdata;
  if (lastEventData && lastEventData.nextCmds && lastEventData.nextCmds === 'C') {
    this._didRecoveredGameSendFinish = true;
  } else {
    this._didRecoveredGameSendFinish = false;
  }

  messageBus.post('game:modal', {
    reason: 'Recovery Popup',
  });
  var message = {
    type: 'common:RecoverGame',
    bpl: this._bpl,
    gameState: this._gameState,
    recoverFromStart: true,
    clientParams: clientParams,
    previousCommands: commandsSent,
    replay: this._inReplayMode,
  };
  if (this._meta) {
    message.metaData = this._meta.name;
    message.metaValue = this._meta.value;
  }

  this._messageQueue.push(message);

  // this task gets held on to by features that need to recover player selection, they leave it when
  // they have finished inputting recovered selection. This way the Dead is only sent when everything has recovered
  // this is so we dont allow the sending of client state back to the engine if the new recovery didnt get as far through
  // as previous recovery.
  var message2 = {
    type: 'common:RecoverGameListener',
    bpl: this._bpl,
    gameState: this._gameState,
    recoverFromStart: true,
    clientParams: clientParams,
    previousCommands: commandsSent,
    replay: this._inReplayMode,
  };
  if (this._meta) {
    message2.metaData = this._meta.name;
    message2.metaValue = this._meta.value;
  }

  this._gameNotFullyRecovered = true;

  // dont add it to the message queue as we dont want to block messages whilst this task is being hung on to
  messageBus.taskImmediate(message2.type, message2);
};

// replace libs version
GatiServer.prototype.getCheatString = function () {
  return this.force;
};

// replace libs version
GatiServer.prototype.logCheatString = function () {
  this.force = this._latestEngineReponse.wager.bets[0].eventdata.response.clientData.Repro;

  if (this.force !== '') {
    console.log('force: ' + this.force);
  }
};

GatiServer.prototype.addCheatToRequest = function (request, forces, index = 0) {
  let forcesJson = forces;

  if (!forcesJson || forcesJson.length === 0) {
    this.forceIndex = 0;
    return;
  }

  if (Array.isArray(forces)) {
    // we may have multiple gambles here
    // so this.gambleForces should ideally be an array
    // for (let i = 1; i < forces.length; i++) {
    //   let foundForceGamble = false;
    //   if (forces[i] !== undefined && this._stake === 100) {
    //     const data = JSON.parse(forces[i]);
    //     const len = data.r.length;

    //     if (data.r[len - 1] === 0) {
    //       foundForceGamble = true;
    //       this.gambleForces.push(forces[i]);
    //     } else {
    //       // this.gambleForces = [];
    //     }
    //   } else {
    //     // this.gambleForces = [];
    //   }

    //   if (!foundForceGamble && this.gambleForces.length > 0) {
    //     // do we have the collect
    //     if (forces[i] !== undefined && this._stake === 100) {
    //       // we have a force for the collect ASSUMING!!!
    //       this.collectForce = forces[i];
    //     } else {
    //       this.collectForce = undefined;
    //     }
    //   } else {
    //     if (forces.length > 1) {
    //       // more than 1 force, and we arent a gamble force
    //       // assume this is for the collect
    //       // im also assuming we will only have 2 in the array
    //       this.collectForce = forces[i];
    //     }
    //   }
    // }
    if (this.forceIndex < forces.length) {
      request.cheat = forces[this.forceIndex];
      this.forceIndex++;
    }
  } else {
    // we shouldnt get here ever again
    request.cheat = forces;
  }
};

GatiServer.prototype.updateForces = function (forces) {
  if (!forces) return undefined;
  let forcesJson = forces;

  if (!forcesJson || forcesJson.length === 0) return;

  return forcesJson;
};

GatiServer.prototype.getGameConfig = function (loadData, cb) {
  if (loadData.settings.preloader && loadData.settings.preloader.hasMessage) {
    this._loadingScreenData.minLoadingTime = loadData.settings.preloader.delay;
    this._loadingScreenData.message = loadData.settings.preloader.message;
    this._loadingScreenData.gamCareLogo = true;
  }

  this.addGameConfigToQueue(loadData);
  this._balance = loadData.settings.balance * 100;
  // no idea why the x10 is needed
  // this is wrong in different currencies anyway
  // this._maxWins = loadData.settings.slotConfig.Config['spinner:GameConfigEvent'].slotConfig.maxmimumWin * 10;
  this._coinSizes = loadData.settings.slotConfig.Config['spinner:GameConfigEvent'].slotConfig.coinSizes;
  this.addShowEventToQueue([]);
  this.addAvailableActionsToQueue();
  this._oldBalance = this._balance;
  this._preCommitBalance = this._balance;
  // this.addBalanceEventToQueue();
  cb();
};

GatiServer.prototype.getMaxWin = function () {
  // use same calculation as used on the pay table
  const stakeController = resourceManager.getController('stakeController');
  const baseStake = stakeController.CurrentBetPerLine * stakeController.CurrentWinLineCount;
  const maxWin = baseStake * gameData.maxExposure;
  return maxWin;
};

GatiServerGame.prototype.addGameCompleteToQueue = function (totalWon) {
  GatiServer.prototype.addGameCompleteToQueue.call(this, totalWon);
  this._forces = '';
  this.forceIndex = 0;
};
